module.exports = __webpack_public_path__ + "0043a77dae4fbb73a67570ecab32bac8.fbx";